<template>
  <div>
    <!-- TKP-153 / tunesoft2 s.1: Periyodik Güncelleme kendi ekranında (Onay sekmesinden taşındı). Ekran içeriği TKP-159/160'ta yeniden düzenlenir. -->
    <h1 class="title">{{ $t("approval.period.menu") }}</h1>
    <approval-period data-test="periodic-update-page" />
  </div>
</template>

<script>
import ApprovalPeriod from "./approval-period";

export default {
  components: { ApprovalPeriod },
};
</script>
